export const styles = {
  inputField: {
    pr: 4,
  },

  resetInputButton: (hide: boolean) => ({
    position: 'absolute',
    right: '0.25rem',
    top: '0.25rem',
    visibility: hide ? 'hidden' : 'visible',
  }),
};
